import React, { useEffect, useState } from 'react';
import './Form.css';
import './FormDeleteAccount.css';
import SelectField from './SelectField';
import TextField from './TextField';
import ActionButton from '../ActionButton';
import langFieldOptions from './langFieldOptions';
import formsConfiguration from './formsConfiguration';
import i18n from '../../i18n';
import filterSelectFields from './filterSelectFields';
import { useAuth } from '../../contexts/AuthContext';
import requests from '../../requests';
import { AUTH_INITIAL_STATE } from '../../constants';
import LoadingLayer from '../LoadingLayer';

export const FormDeleteAccount = ({
    formType,
    isValidationEnabled,
    onFieldUpdate,
    formData,
    lang,
    onSourceUpdate,
    onSoportoFormTypeUpdate,
    forceFormDataUpdate,
    onLanguageChange,
    onSubmitClick,
    fillFormDataFromResponse,
    showLogin
}) => {
    const issueTypes = filterSelectFields.filterSelectOptions(formType, 'issueTypes');
    const issueSubTypes = filterSelectFields.filterSelectNestedOptions(formType, 'issueSubTypes');
    const source = formsConfiguration.form[formType].source;
    const soportoFormType = formsConfiguration.form[formType].soportoFormType;
    const getCopy = (i18nKey) => i18n.getCopy(lang, i18nKey);
    const { state, setState } = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        onSourceUpdate(source);
        onSoportoFormTypeUpdate(soportoFormType);

        const newFormData = {
            issueType: { value: 'privacy', isValid: true },
            issueSubType: { value: 'permanently_delete_my_account', isValid: true },
            message: { value: 'The player has requested to delete its account.', isValid: true },
            platform: { value: '', isValid: true },
            game: { value: '', isValid: true }
        };

        forceFormDataUpdate(newFormData);
    }, []);

    useEffect(() => {
        if (!state.isLoggedIn) {
            showLogin();
        }
    }, [state.isLoggedIn]);

    useEffect(() => {
        if (state.sessionKey) {
            setIsLoading(true);
            requests.getUserData(
                state.sessionKey,
                (response) => {
                    const { email } = response.playerData;
                    if (!email) {
                        setState(AUTH_INITIAL_STATE);
                    }
                    setIsLoading(false);
                    fillFormDataFromResponse(response);
                },
                () => {
                    setState(AUTH_INITIAL_STATE);
                    setIsLoading(false);
                }
            );
        }
    }, [state.sessionKey]);

    return (
        <div className="Form">
            {isLoading && <LoadingLayer />}
            <h1 className={`Form-title`}>{getCopy('form.title')}</h1>
            <form className={`Form-content`} lang={i18n.normalizeLang(lang)}>
                <SelectField
                    fieldConfig={{
                        id: 'lang',
                        label: getCopy('field.label.lang'),
                        validations: {
                            required: true
                        },
                        options: langFieldOptions
                    }}
                    value={lang}
                    onFieldUpdate={onLanguageChange}
                    showValidationError={false}
                />
                <TextField
                    fieldConfig={{
                        id: 'email',
                        label: getCopy('field.label.email'),
                        errorMsg: getCopy('field.error.email'),
                        placeholder: getCopy('field.placeholder.email'),
                        type: 'email',
                        validations: {
                            required: true,
                            email: true
                        }
                    }}
                    value={formData.email.value}
                    onFieldUpdate={onFieldUpdate}
                    showValidationError={isValidationEnabled && !formData.email.isValid}
                    lang={i18n.normalizeLang(lang)}
                />
                <TextField
                    fieldConfig={{
                        id: 'name',
                        label: getCopy('field.label.name'),
                        errorMsg: getCopy('field.error.name'),
                        type: 'text',
                        validations: {
                            required: true
                        }
                    }}
                    value={formData.name.value}
                    onFieldUpdate={onFieldUpdate}
                    showValidationError={isValidationEnabled && !formData.name.isValid}
                    lang={i18n.normalizeLang(lang)}
                />
                <SelectField
                    fieldConfig={{
                        id: 'issueType',
                        label: getCopy('field.label.type'),
                        errorMsg: getCopy('field.error.type'),
                        validations: {
                            required: true
                        },
                        options: issueTypes
                    }}
                    value={formData.issueType.value}
                    onFieldUpdate={(id, value, fieldConfig) => {
                        onFieldUpdate(id, value, fieldConfig, 'issueSubType');
                    }}
                    showValidationError={isValidationEnabled && !formData.issueType.isValid}
                    getCopy={getCopy}
                    disabled
                />
                <SelectField
                    fieldConfig={{
                        id: 'issueSubType',
                        label: getCopy('field.label.subType'),
                        errorMsg: getCopy('field.error.subType'),
                        validations: {
                            required: true
                        },
                        options: issueSubTypes[formData.issueType.value] || []
                    }}
                    value={formData.issueSubType.value}
                    onFieldUpdate={onFieldUpdate}
                    showValidationError={isValidationEnabled && !formData.issueSubType.isValid}
                    getCopy={getCopy}
                    disabled
                />
                <p
                    dangerouslySetInnerHTML={{
                        __html: getCopy('form.label.delete_account_disclaimer').replace(/\\n/g, '<br />')
                    }}
                    className="Disclaimer"
                ></p>
                <ActionButton buttonMsg={getCopy('form.button.delete_account')} onClickButton={onSubmitClick} />
                {isValidationEnabled && <p className="Form-validation-error">{getCopy('validation.error.message')}</p>}
            </form>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/Form/FormDeleteAccount.js